/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface TeamsService {
  /** @summary Get All */
  getAllTeamsGet: {
    /** @summary Get All */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<GetAllTeamsGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetAllTeamsGetSchema,
        options: {
          parameters: GetAllTeamsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAllTeamsGetData, GetAllTeamsGetError>>
    ): Promise<RequestFnResponse<GetAllTeamsGetData, GetAllTeamsGetError>>;
    /** @summary Get All */
    getQueryKey(
      parameters: DeepReadonly<GetAllTeamsGetParameters> | void
    ): ServiceOperationQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.teamsService.getAllTeamsGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllTeamsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>
        | (DeepReadonly<GetAllTeamsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllTeamsGetData,
          GetAllTeamsGetError,
          TData,
          ServiceOperationQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllTeamsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.teamsService.getAllTeamsGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllTeamsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>
        | (DeepReadonly<GetAllTeamsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetAllTeamsGetData,
          GetAllTeamsGetError,
          TData,
          ServiceOperationQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllTeamsGetError>>;
    /** @summary Get All */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllTeamsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.teamsService.getAllTeamsGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllTeamsGetParameters,
      TQueryFnData = GetAllTeamsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllTeamsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>
        | (DeepReadonly<GetAllTeamsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllTeamsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllTeamsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.teamsService.getAllTeamsGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllTeamsGetParameters,
      TQueryFnData = GetAllTeamsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllTeamsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>
        | (DeepReadonly<GetAllTeamsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllTeamsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllTeamsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllTeamsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllTeamsGetTotal = qraft.teamsService.getAllTeamsGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllTeamsGetSchema,
            GetAllTeamsGetData,
            TInfinite,
            GetAllTeamsGetParameters,
            GetAllTeamsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllTeamsGetSchema,
            GetAllTeamsGetData,
            TInfinite,
            GetAllTeamsGetParameters,
            GetAllTeamsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllTeamsGetResults = qraft.teamsService.getAllTeamsGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllTeamsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllTeamsGetCombinedResults = qraft.teamsService.getAllTeamsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllTeamsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllTeamsGetSchema,
          GetAllTeamsGetParameters,
          GetAllTeamsGetData,
          GetAllTeamsGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAllTeamsGetData, GetAllTeamsGetError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetAllTeamsGetData, GetAllTeamsGetError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.teamsService.getAllTeamsGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetAllTeamsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>
        | (DeepReadonly<GetAllTeamsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllTeamsGetData,
          GetAllTeamsGetError,
          TData,
          ServiceOperationQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllTeamsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.teamsService.getAllTeamsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetAllTeamsGetParameters, TData = GetAllTeamsGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>
        | (DeepReadonly<GetAllTeamsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllTeamsGetData,
          GetAllTeamsGetError,
          OperationInfiniteData<TData, GetAllTeamsGetParameters>,
          ServiceOperationInfiniteQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllTeamsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllTeamsGetParameters>,
      OperationError<GetAllTeamsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllTeamsGetData = qraft.teamsService.getAllTeamsGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllTeamsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllTeamsGetCombinedData = qraft.teamsService.getAllTeamsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllTeamsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllTeamsGetSchema,
          GetAllTeamsGetParameters,
          GetAllTeamsGetData,
          GetAllTeamsGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetAllTeamsGetData, GetAllTeamsGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetAllTeamsGetData, GetAllTeamsGetError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get All */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllTeamsGetSchema,
        GetAllTeamsGetData,
        GetAllTeamsGetParameters,
        GetAllTeamsGetError
      > | void
    ): Promise<GetAllTeamsGetData>;
    /** @summary Get All */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllTeamsGetSchema,
        GetAllTeamsGetData,
        GetAllTeamsGetParameters,
        GetAllTeamsGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllTeamsGetSchema,
        GetAllTeamsGetData,
        GetAllTeamsGetParameters,
        GetAllTeamsGetError
      > | void
    ): Promise<GetAllTeamsGetData>;
    /** @summary Get All */
    fetchInfiniteQuery<TPageParam extends GetAllTeamsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllTeamsGetSchema,
        GetAllTeamsGetData,
        GetAllTeamsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllTeamsGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllTeamsGetData, GetAllTeamsGetParameters>>;
    /** @summary Get All */
    prefetchInfiniteQuery<TPageParam extends GetAllTeamsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllTeamsGetSchema,
        GetAllTeamsGetData,
        GetAllTeamsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllTeamsGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureInfiniteQueryData<TPageParam extends GetAllTeamsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllTeamsGetSchema,
        GetAllTeamsGetData,
        GetAllTeamsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllTeamsGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllTeamsGetData, GetAllTeamsGetParameters>>;
    /** @summary Get All */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>
        | (DeepReadonly<GetAllTeamsGetParameters> | void)
    ): GetAllTeamsGetData | undefined;
    /** @summary Get All */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>
        | (DeepReadonly<GetAllTeamsGetParameters> | void)
    ): OperationInfiniteData<GetAllTeamsGetData, GetAllTeamsGetParameters> | undefined;
    /** @summary Get All */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllTeamsGetSchema,
            GetAllTeamsGetData,
            TInfinite,
            GetAllTeamsGetParameters,
            GetAllTeamsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllTeamsGetSchema,
            GetAllTeamsGetData,
            TInfinite,
            GetAllTeamsGetParameters,
            GetAllTeamsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>,
            data: NoInfer<OperationInfiniteData<GetAllTeamsGetData, GetAllTeamsGetParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>,
            data: GetAllTeamsGetData | undefined,
          ]
        >;
    /** @summary Get All */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>
        | (DeepReadonly<GetAllTeamsGetParameters> | void)
    ): QueryState<GetAllTeamsGetData, GetAllTeamsGetError> | undefined;
    /** @summary Get All */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllTeamsGetParameters>
        | ServiceOperationInfiniteQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>
        | void
    ): QueryState<OperationInfiniteData<GetAllTeamsGetData, GetAllTeamsGetParameters>, GetAllTeamsGetError> | undefined;
    /** @summary Get All */
    setQueryData(
      parameters:
        | (DeepReadonly<GetAllTeamsGetParameters> | undefined)
        | ServiceOperationQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>,
      updater: Updater<NoInfer<GetAllTeamsGetData> | undefined, NoInfer<DeepReadonly<GetAllTeamsGetData>> | undefined>,
      options?: SetDataOptions
    ): GetAllTeamsGetData | undefined;
    /** @summary Get All */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetAllTeamsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetAllTeamsGetSchema, GetAllTeamsGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetAllTeamsGetData, GetAllTeamsGetParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetAllTeamsGetData, GetAllTeamsGetParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAllTeamsGetData, GetAllTeamsGetParameters> | undefined;
    /** @summary Get All */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllTeamsGetSchema,
            GetAllTeamsGetData,
            TInfinite,
            GetAllTeamsGetParameters,
            GetAllTeamsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllTeamsGetSchema,
            GetAllTeamsGetData,
            TInfinite,
            GetAllTeamsGetParameters,
            GetAllTeamsGetError
          >,
      updater: Updater<NoInfer<GetAllTeamsGetData> | undefined, NoInfer<GetAllTeamsGetData> | undefined>,
      options?: SetDataOptions
    ): Array<GetAllTeamsGetData | undefined>;
    /** @summary Get All */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllTeamsGetSchema,
        GetAllTeamsGetData,
        TInfinite,
        GetAllTeamsGetParameters,
        GetAllTeamsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get All */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllTeamsGetSchema,
            GetAllTeamsGetData,
            TInfinite,
            GetAllTeamsGetParameters,
            GetAllTeamsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllTeamsGetSchema,
            GetAllTeamsGetData,
            TInfinite,
            GetAllTeamsGetParameters,
            GetAllTeamsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get All */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllTeamsGetSchema,
            GetAllTeamsGetData,
            TInfinite,
            GetAllTeamsGetParameters,
            GetAllTeamsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllTeamsGetSchema,
            GetAllTeamsGetData,
            TInfinite,
            GetAllTeamsGetParameters,
            GetAllTeamsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get All */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllTeamsGetSchema,
            GetAllTeamsGetData,
            TInfinite,
            GetAllTeamsGetParameters,
            GetAllTeamsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllTeamsGetSchema,
            GetAllTeamsGetData,
            TInfinite,
            GetAllTeamsGetParameters,
            GetAllTeamsGetError
          >
    ): void;
    /** @summary Get All */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllTeamsGetSchema,
            GetAllTeamsGetData,
            TInfinite,
            GetAllTeamsGetParameters,
            GetAllTeamsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllTeamsGetSchema,
            GetAllTeamsGetData,
            TInfinite,
            GetAllTeamsGetParameters,
            GetAllTeamsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get All */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllTeamsGetSchema,
            GetAllTeamsGetData,
            TInfinite,
            GetAllTeamsGetParameters,
            GetAllTeamsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllTeamsGetSchema,
            GetAllTeamsGetData,
            TInfinite,
            GetAllTeamsGetParameters,
            GetAllTeamsGetError
          >
    ): number;
    schema: GetAllTeamsGetSchema;
    types: {
      parameters: GetAllTeamsGetParameters;
      data: GetAllTeamsGetData;
      error: GetAllTeamsGetError;
    };
  };
  /** @summary Create */
  createTeamsPost: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateTeamsPostBody, CreateTeamsPostParameters, TMeta, TSignal>,
      client?: (
        schema: CreateTeamsPostSchema,
        options: ServiceOperationMutationFnOptions<CreateTeamsPostBody, CreateTeamsPostParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateTeamsPostData, CreateTeamsPostError>>
    ): Promise<RequestFnResponse<CreateTeamsPostData, CreateTeamsPostError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateTeamsPostParameters> | void
    ): ServiceOperationMutationKey<CreateTeamsPostSchema, CreateTeamsPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.createTeamsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.createTeamsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateTeamsPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateTeamsPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateTeamsPostSchema,
        CreateTeamsPostData,
        CreateTeamsPostParameters,
        TVariables,
        OperationError<CreateTeamsPostError>,
        TContext
      >
    ): UseMutationResult<CreateTeamsPostData, OperationError<CreateTeamsPostError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.createTeamsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.createTeamsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateTeamsPostBody, CreateTeamsPostParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateTeamsPostSchema,
        CreateTeamsPostData,
        CreateTeamsPostParameters,
        TVariables,
        OperationError<CreateTeamsPostError>,
        TContext
      >
    ): UseMutationResult<CreateTeamsPostData, OperationError<CreateTeamsPostError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createTeamsPostTotal = qraft.teamsService.createTeamsPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createTeamsPostTotal = qraft.teamsService.createTeamsPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateTeamsPostBody,
            CreateTeamsPostData,
            CreateTeamsPostParameters,
            OperationError<CreateTeamsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateTeamsPostSchema,
            CreateTeamsPostBody,
            CreateTeamsPostData,
            CreateTeamsPostParameters,
            OperationError<CreateTeamsPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createTeamsPostPendingMutationVariables = qraft.teamsService.createTeamsPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createTeamsPostMutationData = qraft.teamsService.createTeamsPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateTeamsPostData,
        OperationError<CreateTeamsPostError>,
        MutationVariables<CreateTeamsPostBody, CreateTeamsPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateTeamsPostBody,
            CreateTeamsPostData,
            CreateTeamsPostParameters,
            OperationError<CreateTeamsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateTeamsPostSchema,
            CreateTeamsPostBody,
            CreateTeamsPostData,
            CreateTeamsPostParameters,
            OperationError<CreateTeamsPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateTeamsPostData,
          OperationError<CreateTeamsPostError>,
          MutationVariables<CreateTeamsPostBody, CreateTeamsPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateTeamsPostBody,
            CreateTeamsPostData,
            CreateTeamsPostParameters,
            OperationError<CreateTeamsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateTeamsPostSchema,
            CreateTeamsPostBody,
            CreateTeamsPostData,
            CreateTeamsPostParameters,
            OperationError<CreateTeamsPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.teamsService.createTeamsPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.teamsService.createTeamsPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateTeamsPostBody,
              CreateTeamsPostData,
              CreateTeamsPostParameters,
              OperationError<CreateTeamsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateTeamsPostSchema,
              CreateTeamsPostBody,
              CreateTeamsPostData,
              CreateTeamsPostParameters,
              OperationError<CreateTeamsPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateTeamsPostData,
            CreateTeamsPostError,
            MutationVariables<CreateTeamsPostBody, CreateTeamsPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateTeamsPostBody,
              CreateTeamsPostData,
              CreateTeamsPostParameters,
              OperationError<CreateTeamsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateTeamsPostSchema,
              CreateTeamsPostBody,
              CreateTeamsPostData,
              CreateTeamsPostParameters,
              OperationError<CreateTeamsPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateTeamsPostData,
          CreateTeamsPostError,
          MutationVariables<CreateTeamsPostBody, CreateTeamsPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateTeamsPostSchema;
    types: {
      parameters: CreateTeamsPostParameters;
      data: CreateTeamsPostData;
      error: CreateTeamsPostError;
      body: CreateTeamsPostBody;
    };
  };
  /** @summary Get */
  getTeamsTeamIdGet: {
    /** @summary Get */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetTeamsTeamIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetTeamsTeamIdGetSchema,
        options: {
          parameters: GetTeamsTeamIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetTeamsTeamIdGetData, GetTeamsTeamIdGetError>>
    ): Promise<RequestFnResponse<GetTeamsTeamIdGetData, GetTeamsTeamIdGetError>>;
    /** @summary Get */
    getQueryKey(
      parameters: DeepReadonly<GetTeamsTeamIdGetParameters>
    ): ServiceOperationQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.teamsService.getTeamsTeamIdGet.useQuery({
     *     path: {
     *         team_id: teamId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetTeamsTeamIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>
        | DeepReadonly<GetTeamsTeamIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetTeamsTeamIdGetData,
          GetTeamsTeamIdGetError,
          TData,
          ServiceOperationQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetTeamsTeamIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.teamsService.getTeamsTeamIdGet.useQuery({
     *     path: {
     *         team_id: teamId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetTeamsTeamIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>
        | DeepReadonly<GetTeamsTeamIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetTeamsTeamIdGetData,
          GetTeamsTeamIdGetError,
          TData,
          ServiceOperationQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetTeamsTeamIdGetError>>;
    /** @summary Get */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetTeamsTeamIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.teamsService.getTeamsTeamIdGet.useInfiniteQuery({
     *     path: {
     *         team_id: teamId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetTeamsTeamIdGetParameters,
      TQueryFnData = GetTeamsTeamIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetTeamsTeamIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>
        | DeepReadonly<GetTeamsTeamIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetTeamsTeamIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetTeamsTeamIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.teamsService.getTeamsTeamIdGet.useInfiniteQuery({
     *     path: {
     *         team_id: teamId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetTeamsTeamIdGetParameters,
      TQueryFnData = GetTeamsTeamIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetTeamsTeamIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>
        | DeepReadonly<GetTeamsTeamIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetTeamsTeamIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetTeamsTeamIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetTeamsTeamIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getTeamsTeamIdGetTotal = qraft.teamsService.getTeamsTeamIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getTeamsTeamIdGetByParametersTotal = qraft.teamsService.getTeamsTeamIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             team_id: teamId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTeamsTeamIdGetSchema,
            GetTeamsTeamIdGetData,
            TInfinite,
            GetTeamsTeamIdGetParameters,
            GetTeamsTeamIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTeamsTeamIdGetSchema,
            GetTeamsTeamIdGetData,
            TInfinite,
            GetTeamsTeamIdGetParameters,
            GetTeamsTeamIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getTeamsTeamIdGetResults = qraft.teamsService.getTeamsTeamIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 team_id: teamId1
     *             }
     *         },
     *         {
     *             path: {
     *                 team_id: teamId2
     *             }
     *         }
     *     ]
     * });
     * getTeamsTeamIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getTeamsTeamIdGetCombinedResults = qraft.teamsService.getTeamsTeamIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 team_id: teamId1
     *             }
     *         },
     *         {
     *             path: {
     *                 team_id: teamId2
     *             }
     *         }
     *     ]
     * });
     * getTeamsTeamIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetTeamsTeamIdGetSchema,
          GetTeamsTeamIdGetParameters,
          GetTeamsTeamIdGetData,
          GetTeamsTeamIdGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetTeamsTeamIdGetData, GetTeamsTeamIdGetError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetTeamsTeamIdGetData, GetTeamsTeamIdGetError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.teamsService.getTeamsTeamIdGet.useSuspenseQuery({
     *     path: {
     *         team_id: teamId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetTeamsTeamIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>
        | DeepReadonly<GetTeamsTeamIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetTeamsTeamIdGetData,
          GetTeamsTeamIdGetError,
          TData,
          ServiceOperationQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetTeamsTeamIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.teamsService.getTeamsTeamIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         team_id: teamId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetTeamsTeamIdGetParameters, TData = GetTeamsTeamIdGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>
        | DeepReadonly<GetTeamsTeamIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetTeamsTeamIdGetData,
          GetTeamsTeamIdGetError,
          OperationInfiniteData<TData, GetTeamsTeamIdGetParameters>,
          ServiceOperationInfiniteQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetTeamsTeamIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetTeamsTeamIdGetParameters>,
      OperationError<GetTeamsTeamIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getTeamsTeamIdGetData = qraft.teamsService.getTeamsTeamIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 team_id: teamId1
     *             }
     *         },
     *         {
     *             path: {
     *                 team_id: teamId2
     *             }
     *         }
     *     ]
     * });
     * getTeamsTeamIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getTeamsTeamIdGetCombinedData = qraft.teamsService.getTeamsTeamIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 team_id: teamId1
     *             }
     *         },
     *         {
     *             path: {
     *                 team_id: teamId2
     *             }
     *         }
     *     ]
     * });
     * getTeamsTeamIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetTeamsTeamIdGetSchema,
          GetTeamsTeamIdGetParameters,
          GetTeamsTeamIdGetData,
          GetTeamsTeamIdGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetTeamsTeamIdGetData, GetTeamsTeamIdGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetTeamsTeamIdGetData, GetTeamsTeamIdGetError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetTeamsTeamIdGetSchema,
        GetTeamsTeamIdGetData,
        GetTeamsTeamIdGetParameters,
        GetTeamsTeamIdGetError
      >
    ): Promise<GetTeamsTeamIdGetData>;
    /** @summary Get */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetTeamsTeamIdGetSchema,
        GetTeamsTeamIdGetData,
        GetTeamsTeamIdGetParameters,
        GetTeamsTeamIdGetError
      >
    ): Promise<void>;
    /** @summary Get */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetTeamsTeamIdGetSchema,
        GetTeamsTeamIdGetData,
        GetTeamsTeamIdGetParameters,
        GetTeamsTeamIdGetError
      >
    ): Promise<GetTeamsTeamIdGetData>;
    /** @summary Get */
    fetchInfiniteQuery<TPageParam extends GetTeamsTeamIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetTeamsTeamIdGetSchema,
        GetTeamsTeamIdGetData,
        GetTeamsTeamIdGetParameters,
        DeepReadonly<TPageParam>,
        GetTeamsTeamIdGetError
      >
    ): Promise<OperationInfiniteData<GetTeamsTeamIdGetData, GetTeamsTeamIdGetParameters>>;
    /** @summary Get */
    prefetchInfiniteQuery<TPageParam extends GetTeamsTeamIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetTeamsTeamIdGetSchema,
        GetTeamsTeamIdGetData,
        GetTeamsTeamIdGetParameters,
        DeepReadonly<TPageParam>,
        GetTeamsTeamIdGetError
      >
    ): Promise<void>;
    /** @summary Get */
    ensureInfiniteQueryData<TPageParam extends GetTeamsTeamIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetTeamsTeamIdGetSchema,
        GetTeamsTeamIdGetData,
        GetTeamsTeamIdGetParameters,
        DeepReadonly<TPageParam>,
        GetTeamsTeamIdGetError
      >
    ): Promise<OperationInfiniteData<GetTeamsTeamIdGetData, GetTeamsTeamIdGetParameters>>;
    /** @summary Get */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>
        | DeepReadonly<GetTeamsTeamIdGetParameters>
    ): GetTeamsTeamIdGetData | undefined;
    /** @summary Get */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>
        | DeepReadonly<GetTeamsTeamIdGetParameters>
    ): OperationInfiniteData<GetTeamsTeamIdGetData, GetTeamsTeamIdGetParameters> | undefined;
    /** @summary Get */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTeamsTeamIdGetSchema,
            GetTeamsTeamIdGetData,
            TInfinite,
            GetTeamsTeamIdGetParameters,
            GetTeamsTeamIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTeamsTeamIdGetSchema,
            GetTeamsTeamIdGetData,
            TInfinite,
            GetTeamsTeamIdGetParameters,
            GetTeamsTeamIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>,
            data: NoInfer<OperationInfiniteData<GetTeamsTeamIdGetData, GetTeamsTeamIdGetParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>,
            data: GetTeamsTeamIdGetData | undefined,
          ]
        >;
    /** @summary Get */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>
        | DeepReadonly<GetTeamsTeamIdGetParameters>
    ): QueryState<GetTeamsTeamIdGetData, GetTeamsTeamIdGetError> | undefined;
    /** @summary Get */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetTeamsTeamIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>
    ):
      | QueryState<OperationInfiniteData<GetTeamsTeamIdGetData, GetTeamsTeamIdGetParameters>, GetTeamsTeamIdGetError>
      | undefined;
    /** @summary Get */
    setQueryData(
      parameters:
        | DeepReadonly<GetTeamsTeamIdGetParameters>
        | ServiceOperationQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>,
      updater: Updater<
        NoInfer<GetTeamsTeamIdGetData> | undefined,
        NoInfer<DeepReadonly<GetTeamsTeamIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetTeamsTeamIdGetData | undefined;
    /** @summary Get */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetTeamsTeamIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetTeamsTeamIdGetSchema, GetTeamsTeamIdGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetTeamsTeamIdGetData, GetTeamsTeamIdGetParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetTeamsTeamIdGetData, GetTeamsTeamIdGetParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetTeamsTeamIdGetData, GetTeamsTeamIdGetParameters> | undefined;
    /** @summary Get */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetTeamsTeamIdGetSchema,
            GetTeamsTeamIdGetData,
            TInfinite,
            GetTeamsTeamIdGetParameters,
            GetTeamsTeamIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTeamsTeamIdGetSchema,
            GetTeamsTeamIdGetData,
            TInfinite,
            GetTeamsTeamIdGetParameters,
            GetTeamsTeamIdGetError
          >,
      updater: Updater<NoInfer<GetTeamsTeamIdGetData> | undefined, NoInfer<GetTeamsTeamIdGetData> | undefined>,
      options?: SetDataOptions
    ): Array<GetTeamsTeamIdGetData | undefined>;
    /** @summary Get */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetTeamsTeamIdGetSchema,
        GetTeamsTeamIdGetData,
        TInfinite,
        GetTeamsTeamIdGetParameters,
        GetTeamsTeamIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTeamsTeamIdGetSchema,
            GetTeamsTeamIdGetData,
            TInfinite,
            GetTeamsTeamIdGetParameters,
            GetTeamsTeamIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTeamsTeamIdGetSchema,
            GetTeamsTeamIdGetData,
            TInfinite,
            GetTeamsTeamIdGetParameters,
            GetTeamsTeamIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTeamsTeamIdGetSchema,
            GetTeamsTeamIdGetData,
            TInfinite,
            GetTeamsTeamIdGetParameters,
            GetTeamsTeamIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTeamsTeamIdGetSchema,
            GetTeamsTeamIdGetData,
            TInfinite,
            GetTeamsTeamIdGetParameters,
            GetTeamsTeamIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTeamsTeamIdGetSchema,
            GetTeamsTeamIdGetData,
            TInfinite,
            GetTeamsTeamIdGetParameters,
            GetTeamsTeamIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTeamsTeamIdGetSchema,
            GetTeamsTeamIdGetData,
            TInfinite,
            GetTeamsTeamIdGetParameters,
            GetTeamsTeamIdGetError
          >
    ): void;
    /** @summary Get */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTeamsTeamIdGetSchema,
            GetTeamsTeamIdGetData,
            TInfinite,
            GetTeamsTeamIdGetParameters,
            GetTeamsTeamIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTeamsTeamIdGetSchema,
            GetTeamsTeamIdGetData,
            TInfinite,
            GetTeamsTeamIdGetParameters,
            GetTeamsTeamIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTeamsTeamIdGetSchema,
            GetTeamsTeamIdGetData,
            TInfinite,
            GetTeamsTeamIdGetParameters,
            GetTeamsTeamIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTeamsTeamIdGetSchema,
            GetTeamsTeamIdGetData,
            TInfinite,
            GetTeamsTeamIdGetParameters,
            GetTeamsTeamIdGetError
          >
    ): number;
    schema: GetTeamsTeamIdGetSchema;
    types: {
      parameters: GetTeamsTeamIdGetParameters;
      data: GetTeamsTeamIdGetData;
      error: GetTeamsTeamIdGetError;
    };
  };
  /** @summary Update */
  updateTeamsTeamIdPatch: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateTeamsTeamIdPatchBody,
        UpdateTeamsTeamIdPatchParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateTeamsTeamIdPatchSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateTeamsTeamIdPatchBody,
          UpdateTeamsTeamIdPatchParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<UpdateTeamsTeamIdPatchData, UpdateTeamsTeamIdPatchError>>
    ): Promise<RequestFnResponse<UpdateTeamsTeamIdPatchData, UpdateTeamsTeamIdPatchError>>;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateTeamsTeamIdPatchParameters> | void
    ): ServiceOperationMutationKey<UpdateTeamsTeamIdPatchSchema, UpdateTeamsTeamIdPatchParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.updateTeamsTeamIdPatch.useMutation({
     *     path: {
     *         team_id: teamId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.updateTeamsTeamIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         team_id: teamId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateTeamsTeamIdPatchBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateTeamsTeamIdPatchParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateTeamsTeamIdPatchSchema,
        UpdateTeamsTeamIdPatchData,
        UpdateTeamsTeamIdPatchParameters,
        TVariables,
        OperationError<UpdateTeamsTeamIdPatchError>,
        TContext
      >
    ): UseMutationResult<UpdateTeamsTeamIdPatchData, OperationError<UpdateTeamsTeamIdPatchError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.updateTeamsTeamIdPatch.useMutation({
     *     path: {
     *         team_id: teamId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.updateTeamsTeamIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         team_id: teamId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateTeamsTeamIdPatchBody, UpdateTeamsTeamIdPatchParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateTeamsTeamIdPatchSchema,
        UpdateTeamsTeamIdPatchData,
        UpdateTeamsTeamIdPatchParameters,
        TVariables,
        OperationError<UpdateTeamsTeamIdPatchError>,
        TContext
      >
    ): UseMutationResult<UpdateTeamsTeamIdPatchData, OperationError<UpdateTeamsTeamIdPatchError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateTeamsTeamIdPatchTotal = qraft.teamsService.updateTeamsTeamIdPatch.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateTeamsTeamIdPatchTotal = qraft.teamsService.updateTeamsTeamIdPatch.useIsMutating({
     *     parameters: {
     *         path: {
     *             team_id: teamId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateTeamsTeamIdPatchBody,
            UpdateTeamsTeamIdPatchData,
            UpdateTeamsTeamIdPatchParameters,
            OperationError<UpdateTeamsTeamIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateTeamsTeamIdPatchSchema,
            UpdateTeamsTeamIdPatchBody,
            UpdateTeamsTeamIdPatchData,
            UpdateTeamsTeamIdPatchParameters,
            OperationError<UpdateTeamsTeamIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateTeamsTeamIdPatchPendingMutationVariables = qraft.teamsService.updateTeamsTeamIdPatch.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateTeamsTeamIdPatchMutationData = qraft.teamsService.updateTeamsTeamIdPatch.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 team_id: teamId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateTeamsTeamIdPatchData,
        OperationError<UpdateTeamsTeamIdPatchError>,
        MutationVariables<UpdateTeamsTeamIdPatchBody, UpdateTeamsTeamIdPatchParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateTeamsTeamIdPatchBody,
            UpdateTeamsTeamIdPatchData,
            UpdateTeamsTeamIdPatchParameters,
            OperationError<UpdateTeamsTeamIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateTeamsTeamIdPatchSchema,
            UpdateTeamsTeamIdPatchBody,
            UpdateTeamsTeamIdPatchData,
            UpdateTeamsTeamIdPatchParameters,
            OperationError<UpdateTeamsTeamIdPatchError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateTeamsTeamIdPatchData,
          OperationError<UpdateTeamsTeamIdPatchError>,
          MutationVariables<UpdateTeamsTeamIdPatchBody, UpdateTeamsTeamIdPatchParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateTeamsTeamIdPatchBody,
            UpdateTeamsTeamIdPatchData,
            UpdateTeamsTeamIdPatchParameters,
            OperationError<UpdateTeamsTeamIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateTeamsTeamIdPatchSchema,
            UpdateTeamsTeamIdPatchBody,
            UpdateTeamsTeamIdPatchData,
            UpdateTeamsTeamIdPatchParameters,
            OperationError<UpdateTeamsTeamIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.teamsService.updateTeamsTeamIdPatch.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             team_id: teamId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.teamsService.updateTeamsTeamIdPatch.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateTeamsTeamIdPatchBody,
              UpdateTeamsTeamIdPatchData,
              UpdateTeamsTeamIdPatchParameters,
              OperationError<UpdateTeamsTeamIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateTeamsTeamIdPatchSchema,
              UpdateTeamsTeamIdPatchBody,
              UpdateTeamsTeamIdPatchData,
              UpdateTeamsTeamIdPatchParameters,
              OperationError<UpdateTeamsTeamIdPatchError>,
              TContext
            >
      ):
        | Mutation<
            UpdateTeamsTeamIdPatchData,
            UpdateTeamsTeamIdPatchError,
            MutationVariables<UpdateTeamsTeamIdPatchBody, UpdateTeamsTeamIdPatchParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateTeamsTeamIdPatchBody,
              UpdateTeamsTeamIdPatchData,
              UpdateTeamsTeamIdPatchParameters,
              OperationError<UpdateTeamsTeamIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateTeamsTeamIdPatchSchema,
              UpdateTeamsTeamIdPatchBody,
              UpdateTeamsTeamIdPatchData,
              UpdateTeamsTeamIdPatchParameters,
              OperationError<UpdateTeamsTeamIdPatchError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateTeamsTeamIdPatchData,
          UpdateTeamsTeamIdPatchError,
          MutationVariables<UpdateTeamsTeamIdPatchBody, UpdateTeamsTeamIdPatchParameters>,
          TContext
        >
      >;
    };
    schema: UpdateTeamsTeamIdPatchSchema;
    types: {
      parameters: UpdateTeamsTeamIdPatchParameters;
      data: UpdateTeamsTeamIdPatchData;
      error: UpdateTeamsTeamIdPatchError;
      body: UpdateTeamsTeamIdPatchBody;
    };
  };
  /** @summary Remove */
  removeTeamsTeamIdDelete: {
    /** @summary Remove */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        RemoveTeamsTeamIdDeleteBody,
        RemoveTeamsTeamIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: RemoveTeamsTeamIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          RemoveTeamsTeamIdDeleteBody,
          RemoveTeamsTeamIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<RemoveTeamsTeamIdDeleteData, RemoveTeamsTeamIdDeleteError>>
    ): Promise<RequestFnResponse<RemoveTeamsTeamIdDeleteData, RemoveTeamsTeamIdDeleteError>>;
    /** @summary Remove */
    getMutationKey(
      parameters: DeepReadonly<RemoveTeamsTeamIdDeleteParameters> | void
    ): ServiceOperationMutationKey<RemoveTeamsTeamIdDeleteSchema, RemoveTeamsTeamIdDeleteParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.removeTeamsTeamIdDelete.useMutation({
     *     path: {
     *         team_id: teamId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.removeTeamsTeamIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         team_id: teamId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends RemoveTeamsTeamIdDeleteBody, TContext = unknown>(
      parameters: DeepReadonly<RemoveTeamsTeamIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        RemoveTeamsTeamIdDeleteSchema,
        RemoveTeamsTeamIdDeleteData,
        RemoveTeamsTeamIdDeleteParameters,
        TVariables,
        OperationError<RemoveTeamsTeamIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      RemoveTeamsTeamIdDeleteData,
      OperationError<RemoveTeamsTeamIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.removeTeamsTeamIdDelete.useMutation({
     *     path: {
     *         team_id: teamId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.removeTeamsTeamIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         team_id: teamId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<RemoveTeamsTeamIdDeleteBody, RemoveTeamsTeamIdDeleteParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        RemoveTeamsTeamIdDeleteSchema,
        RemoveTeamsTeamIdDeleteData,
        RemoveTeamsTeamIdDeleteParameters,
        TVariables,
        OperationError<RemoveTeamsTeamIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      RemoveTeamsTeamIdDeleteData,
      OperationError<RemoveTeamsTeamIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const removeTeamsTeamIdDeleteTotal = qraft.teamsService.removeTeamsTeamIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const removeTeamsTeamIdDeleteTotal = qraft.teamsService.removeTeamsTeamIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             team_id: teamId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            RemoveTeamsTeamIdDeleteBody,
            RemoveTeamsTeamIdDeleteData,
            RemoveTeamsTeamIdDeleteParameters,
            OperationError<RemoveTeamsTeamIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveTeamsTeamIdDeleteSchema,
            RemoveTeamsTeamIdDeleteBody,
            RemoveTeamsTeamIdDeleteData,
            RemoveTeamsTeamIdDeleteParameters,
            OperationError<RemoveTeamsTeamIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const removeTeamsTeamIdDeletePendingMutationVariables = qraft.teamsService.removeTeamsTeamIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const removeTeamsTeamIdDeleteMutationData = qraft.teamsService.removeTeamsTeamIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 team_id: teamId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        RemoveTeamsTeamIdDeleteData,
        OperationError<RemoveTeamsTeamIdDeleteError>,
        MutationVariables<RemoveTeamsTeamIdDeleteBody, RemoveTeamsTeamIdDeleteParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            RemoveTeamsTeamIdDeleteBody,
            RemoveTeamsTeamIdDeleteData,
            RemoveTeamsTeamIdDeleteParameters,
            OperationError<RemoveTeamsTeamIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveTeamsTeamIdDeleteSchema,
            RemoveTeamsTeamIdDeleteBody,
            RemoveTeamsTeamIdDeleteData,
            RemoveTeamsTeamIdDeleteParameters,
            OperationError<RemoveTeamsTeamIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          RemoveTeamsTeamIdDeleteData,
          OperationError<RemoveTeamsTeamIdDeleteError>,
          MutationVariables<RemoveTeamsTeamIdDeleteBody, RemoveTeamsTeamIdDeleteParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Remove */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            RemoveTeamsTeamIdDeleteBody,
            RemoveTeamsTeamIdDeleteData,
            RemoveTeamsTeamIdDeleteParameters,
            OperationError<RemoveTeamsTeamIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveTeamsTeamIdDeleteSchema,
            RemoveTeamsTeamIdDeleteBody,
            RemoveTeamsTeamIdDeleteData,
            RemoveTeamsTeamIdDeleteParameters,
            OperationError<RemoveTeamsTeamIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.teamsService.removeTeamsTeamIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             team_id: teamId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.teamsService.removeTeamsTeamIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              RemoveTeamsTeamIdDeleteBody,
              RemoveTeamsTeamIdDeleteData,
              RemoveTeamsTeamIdDeleteParameters,
              OperationError<RemoveTeamsTeamIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RemoveTeamsTeamIdDeleteSchema,
              RemoveTeamsTeamIdDeleteBody,
              RemoveTeamsTeamIdDeleteData,
              RemoveTeamsTeamIdDeleteParameters,
              OperationError<RemoveTeamsTeamIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            RemoveTeamsTeamIdDeleteData,
            RemoveTeamsTeamIdDeleteError,
            MutationVariables<RemoveTeamsTeamIdDeleteBody, RemoveTeamsTeamIdDeleteParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              RemoveTeamsTeamIdDeleteBody,
              RemoveTeamsTeamIdDeleteData,
              RemoveTeamsTeamIdDeleteParameters,
              OperationError<RemoveTeamsTeamIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RemoveTeamsTeamIdDeleteSchema,
              RemoveTeamsTeamIdDeleteBody,
              RemoveTeamsTeamIdDeleteData,
              RemoveTeamsTeamIdDeleteParameters,
              OperationError<RemoveTeamsTeamIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          RemoveTeamsTeamIdDeleteData,
          RemoveTeamsTeamIdDeleteError,
          MutationVariables<RemoveTeamsTeamIdDeleteBody, RemoveTeamsTeamIdDeleteParameters>,
          TContext
        >
      >;
    };
    schema: RemoveTeamsTeamIdDeleteSchema;
    types: {
      parameters: RemoveTeamsTeamIdDeleteParameters;
      data: RemoveTeamsTeamIdDeleteData;
      error: RemoveTeamsTeamIdDeleteError;
      body: RemoveTeamsTeamIdDeleteBody;
    };
  };
  /** @summary Add Members */
  addMembersTeamsTeamIdMembersPost: {
    /** @summary Add Members */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        AddMembersTeamsTeamIdMembersPostBody,
        AddMembersTeamsTeamIdMembersPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: AddMembersTeamsTeamIdMembersPostSchema,
        options: ServiceOperationMutationFnOptions<
          AddMembersTeamsTeamIdMembersPostBody,
          AddMembersTeamsTeamIdMembersPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<AddMembersTeamsTeamIdMembersPostData, AddMembersTeamsTeamIdMembersPostError>>
    ): Promise<RequestFnResponse<AddMembersTeamsTeamIdMembersPostData, AddMembersTeamsTeamIdMembersPostError>>;
    /** @summary Add Members */
    getMutationKey(
      parameters: DeepReadonly<AddMembersTeamsTeamIdMembersPostParameters> | void
    ): ServiceOperationMutationKey<AddMembersTeamsTeamIdMembersPostSchema, AddMembersTeamsTeamIdMembersPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Add Members
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.addMembersTeamsTeamIdMembersPost.useMutation({
     *     path: {
     *         team_id: teamId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.addMembersTeamsTeamIdMembersPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         team_id: teamId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends AddMembersTeamsTeamIdMembersPostBody, TContext = unknown>(
      parameters: DeepReadonly<AddMembersTeamsTeamIdMembersPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        AddMembersTeamsTeamIdMembersPostSchema,
        AddMembersTeamsTeamIdMembersPostData,
        AddMembersTeamsTeamIdMembersPostParameters,
        TVariables,
        OperationError<AddMembersTeamsTeamIdMembersPostError>,
        TContext
      >
    ): UseMutationResult<
      AddMembersTeamsTeamIdMembersPostData,
      OperationError<AddMembersTeamsTeamIdMembersPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Add Members
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.addMembersTeamsTeamIdMembersPost.useMutation({
     *     path: {
     *         team_id: teamId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.addMembersTeamsTeamIdMembersPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         team_id: teamId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        AddMembersTeamsTeamIdMembersPostBody,
        AddMembersTeamsTeamIdMembersPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        AddMembersTeamsTeamIdMembersPostSchema,
        AddMembersTeamsTeamIdMembersPostData,
        AddMembersTeamsTeamIdMembersPostParameters,
        TVariables,
        OperationError<AddMembersTeamsTeamIdMembersPostError>,
        TContext
      >
    ): UseMutationResult<
      AddMembersTeamsTeamIdMembersPostData,
      OperationError<AddMembersTeamsTeamIdMembersPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Add Members
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const addMembersTeamsTeamIdMembersPostTotal = qraft.teamsService.addMembersTeamsTeamIdMembersPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const addMembersTeamsTeamIdMembersPostTotal = qraft.teamsService.addMembersTeamsTeamIdMembersPost.useIsMutating({
     *     parameters: {
     *         path: {
     *             team_id: teamId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            AddMembersTeamsTeamIdMembersPostBody,
            AddMembersTeamsTeamIdMembersPostData,
            AddMembersTeamsTeamIdMembersPostParameters,
            OperationError<AddMembersTeamsTeamIdMembersPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AddMembersTeamsTeamIdMembersPostSchema,
            AddMembersTeamsTeamIdMembersPostBody,
            AddMembersTeamsTeamIdMembersPostData,
            AddMembersTeamsTeamIdMembersPostParameters,
            OperationError<AddMembersTeamsTeamIdMembersPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Add Members
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const addMembersTeamsTeamIdMembersPostPendingMutationVariables = qraft.teamsService.addMembersTeamsTeamIdMembersPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const addMembersTeamsTeamIdMembersPostMutationData = qraft.teamsService.addMembersTeamsTeamIdMembersPost.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 team_id: teamId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        AddMembersTeamsTeamIdMembersPostData,
        OperationError<AddMembersTeamsTeamIdMembersPostError>,
        MutationVariables<AddMembersTeamsTeamIdMembersPostBody, AddMembersTeamsTeamIdMembersPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            AddMembersTeamsTeamIdMembersPostBody,
            AddMembersTeamsTeamIdMembersPostData,
            AddMembersTeamsTeamIdMembersPostParameters,
            OperationError<AddMembersTeamsTeamIdMembersPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AddMembersTeamsTeamIdMembersPostSchema,
            AddMembersTeamsTeamIdMembersPostBody,
            AddMembersTeamsTeamIdMembersPostData,
            AddMembersTeamsTeamIdMembersPostParameters,
            OperationError<AddMembersTeamsTeamIdMembersPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          AddMembersTeamsTeamIdMembersPostData,
          OperationError<AddMembersTeamsTeamIdMembersPostError>,
          MutationVariables<AddMembersTeamsTeamIdMembersPostBody, AddMembersTeamsTeamIdMembersPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Add Members */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            AddMembersTeamsTeamIdMembersPostBody,
            AddMembersTeamsTeamIdMembersPostData,
            AddMembersTeamsTeamIdMembersPostParameters,
            OperationError<AddMembersTeamsTeamIdMembersPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AddMembersTeamsTeamIdMembersPostSchema,
            AddMembersTeamsTeamIdMembersPostBody,
            AddMembersTeamsTeamIdMembersPostData,
            AddMembersTeamsTeamIdMembersPostParameters,
            OperationError<AddMembersTeamsTeamIdMembersPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Add Members
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.teamsService.addMembersTeamsTeamIdMembersPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             team_id: teamId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.teamsService.addMembersTeamsTeamIdMembersPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              AddMembersTeamsTeamIdMembersPostBody,
              AddMembersTeamsTeamIdMembersPostData,
              AddMembersTeamsTeamIdMembersPostParameters,
              OperationError<AddMembersTeamsTeamIdMembersPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AddMembersTeamsTeamIdMembersPostSchema,
              AddMembersTeamsTeamIdMembersPostBody,
              AddMembersTeamsTeamIdMembersPostData,
              AddMembersTeamsTeamIdMembersPostParameters,
              OperationError<AddMembersTeamsTeamIdMembersPostError>,
              TContext
            >
      ):
        | Mutation<
            AddMembersTeamsTeamIdMembersPostData,
            AddMembersTeamsTeamIdMembersPostError,
            MutationVariables<AddMembersTeamsTeamIdMembersPostBody, AddMembersTeamsTeamIdMembersPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              AddMembersTeamsTeamIdMembersPostBody,
              AddMembersTeamsTeamIdMembersPostData,
              AddMembersTeamsTeamIdMembersPostParameters,
              OperationError<AddMembersTeamsTeamIdMembersPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AddMembersTeamsTeamIdMembersPostSchema,
              AddMembersTeamsTeamIdMembersPostBody,
              AddMembersTeamsTeamIdMembersPostData,
              AddMembersTeamsTeamIdMembersPostParameters,
              OperationError<AddMembersTeamsTeamIdMembersPostError>,
              TContext
            >
      ): Array<
        Mutation<
          AddMembersTeamsTeamIdMembersPostData,
          AddMembersTeamsTeamIdMembersPostError,
          MutationVariables<AddMembersTeamsTeamIdMembersPostBody, AddMembersTeamsTeamIdMembersPostParameters>,
          TContext
        >
      >;
    };
    schema: AddMembersTeamsTeamIdMembersPostSchema;
    types: {
      parameters: AddMembersTeamsTeamIdMembersPostParameters;
      data: AddMembersTeamsTeamIdMembersPostData;
      error: AddMembersTeamsTeamIdMembersPostError;
      body: AddMembersTeamsTeamIdMembersPostBody;
    };
  };
  /** @summary Remove Member */
  removeMemberTeamsTeamIdMembersEmployeeIdDelete: {
    /** @summary Remove Member */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody,
        RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody,
          RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
          RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError
        >
      >
    ): Promise<
      RequestFnResponse<
        RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
        RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError
      >
    >;
    /** @summary Remove Member */
    getMutationKey(
      parameters: DeepReadonly<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters> | void
    ): ServiceOperationMutationKey<
      RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteSchema,
      RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Remove Member
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.removeMemberTeamsTeamIdMembersEmployeeIdDelete.useMutation({
     *     path: {
     *         team_id: teamId,
     *         employee_id: employeeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.removeMemberTeamsTeamIdMembersEmployeeIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         team_id: teamId,
     *         employee_id: employeeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody, TContext = unknown>(
      parameters: DeepReadonly<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteSchema,
        RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
        RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters,
        TVariables,
        OperationError<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
      OperationError<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Remove Member
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.removeMemberTeamsTeamIdMembersEmployeeIdDelete.useMutation({
     *     path: {
     *         team_id: teamId,
     *         employee_id: employeeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.teamsService.removeMemberTeamsTeamIdMembersEmployeeIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         team_id: teamId,
     *         employee_id: employeeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody,
        RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteSchema,
        RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
        RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters,
        TVariables,
        OperationError<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
      OperationError<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Remove Member
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const removeMemberTeamsTeamIdMembersEmployeeIdDeleteTotal = qraft.teamsService.removeMemberTeamsTeamIdMembersEmployeeIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const removeMemberTeamsTeamIdMembersEmployeeIdDeleteTotal = qraft.teamsService.removeMemberTeamsTeamIdMembersEmployeeIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             team_id: teamId,
     *             employee_id: employeeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters,
            OperationError<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteSchema,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters,
            OperationError<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Remove Member
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const removeMemberTeamsTeamIdMembersEmployeeIdDeletePendingMutationVariables = qraft.teamsService.removeMemberTeamsTeamIdMembersEmployeeIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const removeMemberTeamsTeamIdMembersEmployeeIdDeleteMutationData = qraft.teamsService.removeMemberTeamsTeamIdMembersEmployeeIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 team_id: teamId,
     *                 employee_id: employeeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
        OperationError<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError>,
        MutationVariables<
          RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody,
          RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters,
            OperationError<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteSchema,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters,
            OperationError<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
          OperationError<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError>,
          MutationVariables<
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Remove Member */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters,
            OperationError<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteSchema,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters,
            OperationError<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Remove Member
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.teamsService.removeMemberTeamsTeamIdMembersEmployeeIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             team_id: teamId,
     *             employee_id: employeeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.teamsService.removeMemberTeamsTeamIdMembersEmployeeIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody,
              RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
              RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters,
              OperationError<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteSchema,
              RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody,
              RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
              RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters,
              OperationError<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError,
            MutationVariables<
              RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody,
              RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody,
              RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
              RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters,
              OperationError<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteSchema,
              RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody,
              RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
              RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters,
              OperationError<RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData,
          RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError,
          MutationVariables<
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody,
            RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters
          >,
          TContext
        >
      >;
    };
    schema: RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteSchema;
    types: {
      parameters: RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters;
      data: RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData;
      error: RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError;
      body: RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody;
    };
  };
}
/** @summary Get All */
export const getAllTeamsGet = {
  schema: {
    method: 'get',
    url: '/teams',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllTeamsGetSchema;
  [QraftServiceOperationsToken]: TeamsService['getAllTeamsGet'];
};
/** @summary Create */
export const createTeamsPost = {
  schema: {
    method: 'post',
    url: '/teams',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateTeamsPostSchema;
  [QraftServiceOperationsToken]: TeamsService['createTeamsPost'];
};
/** @summary Get */
export const getTeamsTeamIdGet = {
  schema: {
    method: 'get',
    url: '/teams/{team_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetTeamsTeamIdGetSchema;
  [QraftServiceOperationsToken]: TeamsService['getTeamsTeamIdGet'];
};
/** @summary Update */
export const updateTeamsTeamIdPatch = {
  schema: {
    method: 'patch',
    url: '/teams/{team_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateTeamsTeamIdPatchSchema;
  [QraftServiceOperationsToken]: TeamsService['updateTeamsTeamIdPatch'];
};
/** @summary Remove */
export const removeTeamsTeamIdDelete = {
  schema: {
    method: 'delete',
    url: '/teams/{team_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: RemoveTeamsTeamIdDeleteSchema;
  [QraftServiceOperationsToken]: TeamsService['removeTeamsTeamIdDelete'];
};
/** @summary Add Members */
export const addMembersTeamsTeamIdMembersPost = {
  schema: {
    method: 'post',
    url: '/teams/{team_id}/members',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: AddMembersTeamsTeamIdMembersPostSchema;
  [QraftServiceOperationsToken]: TeamsService['addMembersTeamsTeamIdMembersPost'];
};
/** @summary Remove Member */
export const removeMemberTeamsTeamIdMembersEmployeeIdDelete = {
  schema: {
    method: 'delete',
    url: '/teams/{team_id}/members/{employee_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteSchema;
  [QraftServiceOperationsToken]: TeamsService['removeMemberTeamsTeamIdMembersEmployeeIdDelete'];
};
export const teamsService = {
  getAllTeamsGet,
  createTeamsPost,
  getTeamsTeamIdGet,
  updateTeamsTeamIdPatch,
  removeTeamsTeamIdDelete,
  addMembersTeamsTeamIdMembersPost,
  removeMemberTeamsTeamIdMembersEmployeeIdDelete,
} as const;
type GetAllTeamsGetSchema = {
  method: 'get';
  url: '/teams';
  security: ['HTTPBearer'];
};
type GetAllTeamsGetParameters = undefined;
type GetAllTeamsGetData = paths['/teams']['get']['responses']['200']['content']['application/json'];
type GetAllTeamsGetError = unknown;
type CreateTeamsPostSchema = {
  method: 'post';
  url: '/teams';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateTeamsPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateTeamsPostData = paths['/teams']['post']['responses']['200']['content']['application/json'];
type CreateTeamsPostError = paths['/teams']['post']['responses']['422']['content']['application/json'];
type CreateTeamsPostBody = paths['/teams']['post']['requestBody']['content']['application/json'];
type GetTeamsTeamIdGetSchema = {
  method: 'get';
  url: '/teams/{team_id}';
  security: ['HTTPBearer'];
};
type GetTeamsTeamIdGetParameters = paths['/teams/{team_id}']['get']['parameters'];
type GetTeamsTeamIdGetData = paths['/teams/{team_id}']['get']['responses']['200']['content']['application/json'];
type GetTeamsTeamIdGetError = paths['/teams/{team_id}']['get']['responses']['422']['content']['application/json'];
type UpdateTeamsTeamIdPatchSchema = {
  method: 'patch';
  url: '/teams/{team_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateTeamsTeamIdPatchParameters = paths['/teams/{team_id}']['patch']['parameters'];
type UpdateTeamsTeamIdPatchData = paths['/teams/{team_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateTeamsTeamIdPatchError =
  paths['/teams/{team_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateTeamsTeamIdPatchBody = paths['/teams/{team_id}']['patch']['requestBody']['content']['application/json'];
type RemoveTeamsTeamIdDeleteSchema = {
  method: 'delete';
  url: '/teams/{team_id}';
  security: ['HTTPBearer'];
};
type RemoveTeamsTeamIdDeleteParameters = paths['/teams/{team_id}']['delete']['parameters'];
type RemoveTeamsTeamIdDeleteData =
  paths['/teams/{team_id}']['delete']['responses']['200']['content']['application/json'];
type RemoveTeamsTeamIdDeleteError =
  paths['/teams/{team_id}']['delete']['responses']['422']['content']['application/json'];
type RemoveTeamsTeamIdDeleteBody = undefined;
type AddMembersTeamsTeamIdMembersPostSchema = {
  method: 'post';
  url: '/teams/{team_id}/members';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type AddMembersTeamsTeamIdMembersPostParameters = paths['/teams/{team_id}/members']['post']['parameters'];
type AddMembersTeamsTeamIdMembersPostData =
  paths['/teams/{team_id}/members']['post']['responses']['200']['content']['application/json'];
type AddMembersTeamsTeamIdMembersPostError =
  paths['/teams/{team_id}/members']['post']['responses']['422']['content']['application/json'];
type AddMembersTeamsTeamIdMembersPostBody =
  paths['/teams/{team_id}/members']['post']['requestBody']['content']['application/json'];
type RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteSchema = {
  method: 'delete';
  url: '/teams/{team_id}/members/{employee_id}';
  security: ['HTTPBearer'];
};
type RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteParameters =
  paths['/teams/{team_id}/members/{employee_id}']['delete']['parameters'];
type RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteData =
  paths['/teams/{team_id}/members/{employee_id}']['delete']['responses']['200']['content']['application/json'];
type RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteError =
  paths['/teams/{team_id}/members/{employee_id}']['delete']['responses']['422']['content']['application/json'];
type RemoveMemberTeamsTeamIdMembersEmployeeIdDeleteBody = undefined;
